import React, { useMemo } from "react";
import { MUITable } from "../../../../common/components";
import LeadsStatus from "../../leads-status";
import { Checkbox, Tooltip } from "@mui/material";
import { LeadsListTableProps } from "../lead-assignment-props";
import { SortOption } from "../../../tenant/tenant-list/tenant-list-helper";
import LeadFilterOptions from "../../lead-filter/lead-filter-options";
import "./lead-list-table.scss";

const LeadsListTable: React.FC<LeadsListTableProps> = ({
  isAllSelected,
  isIndeterminate,
  setSelectedLeadsMap,
  currentPage,
  selectedLeadsMap,
  setCurrentPage,
  setSortOption,
  data,
 customClassName,
 isOpenFilter,
 selectedLeadsFilter,
 setIsOpenFilter,
 setSelectedLeadsFilters,
 selectedLeadsFilterOptions,
 setAlertMessage,
 setAlertType,
 setSelectedLeadsFilterOptions,
 setActiveFilters,
 setAlertOpen,
 noResultsTxt,
  fieldName,
  viewOpen,
  setViewOpen,
  handleViewClick,
  activeFilters
}) => {
  const fetchFullName = (item: any) => {
    const firstName = item?.first_name?.trim();
    const middleName = item?.middle_name?.trim();
    const lastName = item?.last_name?.trim();

    if (middleName) {
      return `${firstName || ""} ${middleName} ${lastName || ""}`.trim();
    }

    if (firstName || lastName) {
      return `${firstName || ""} ${lastName || ""}`.trim();
    }

    return "-";
  };

  const formattedData = useMemo(() => {
    if (Array.isArray(data)) {
      return data.map((item: any) => {
        const leadName = fetchFullName(item);
        const leadOwnerName = fetchFullName(item?.owner);
        return {
          id: item.id,
          leadName: leadName,
          email: item.primary_email_address || "-",
          phone: item.primary_phone_number || "-",
          leadSource: item.lead_source || "-",
          leadOwner: leadOwnerName,
          leadStatus: item.lead_status || "-",
        };
      });
    }
    return [];
  }, [data]);
  const handleSelectAll = () => {
    setSelectedLeadsMap((prev: any) => {
      const currentPageLeads = data.map((item: any) => item.id);
      const selectedLeadsOnPage = prev[currentPage] || [];

      if (selectedLeadsOnPage.length > 0) {
        return { ...prev, [currentPage]: [] };
      }
      return { ...prev, [currentPage]: currentPageLeads };
    });
  };

  const mapColumnNameToField = (columnName: string): string => {
    const mapping: Record<string, string> = {
      leadName: "first_name",
      email: "primary_email_address",
      phone: "primary_phone_number",
      leadSource: "lead_source",
      leadOwner: "lead_owner",
      leadStatus: "lead_status",
    };

    return mapping[columnName] || columnName;
  };

  const handleSort = (column: string, sortType: string) => {
    let sortValues: SortOption = { sortBy: null, sortDirection: null };
    if (sortType !== "Unsort") {
      const mappedField = mapColumnNameToField(column);
      sortValues = { sortBy: mappedField, sortDirection: sortType };
    }
    setCurrentPage(1);
    setSortOption(sortValues);
  };

  const headers = [
    ...(fieldName !== "approved-leads-list"
      ? [
          {
            key: "select",
            label: (
              <Checkbox
                checked={isAllSelected}
                indeterminate={isIndeterminate}
                onChange={handleSelectAll}
              />
            ),
          },
        ]
      : []),
    { key: "leadName", label: "Lead Name", isSortable: true },
    { key: "email", label: "Email", isSortable: true },
    { key: "phone", label: "Phone Number", isSortable: true },
    { key: "leadSource", label: "Lead Source", isSortable: true },
    { key: "leadOwner", label: "Lead Owner", isSortable: true },
    { key: "leadStatus", label: "Lead Status", isSortable: true },
  ];

  const handleCheckboxChange = (id: number) => {
    setSelectedLeadsMap((prev: any) => {
      const prevSelected = prev[currentPage] || [];
      const newSelected = prevSelected.includes(id)
        ? prevSelected.filter((leadId: number) => leadId !== id)
        : [...prevSelected, id];

      return {
        ...prev,
        [currentPage]: newSelected,
      };
    });
  };

  return (
    <div
      className={`lead-list-table-container ${customClassName}`}
    >
      <div className="table-and-filters-wrapper">
        <div className={`lead-list-table ${fieldName}`}>
          <MUITable
            headers={headers}
            data={formattedData.map((item: any) => ({
              key: item?.id,
              select: (
                <Checkbox
                  checked={
                    selectedLeadsMap[currentPage]?.includes(item?.id) || false
                  }
                  onChange={() => handleCheckboxChange(item?.id)}
                  onClick={(event) => event.stopPropagation()}
                />
              ),
              leadName: item.leadName,
              email: item.email,
              phone: item.phone,
              leadSource: item.leadSource,
              leadOwner: item.leadOwner,
              leadStatus: <LeadsStatus status={item.leadStatus} />,
            }))}
            onSort={handleSort}
            noResultsTxt={noResultsTxt}
            onRowClick={(rowData: any) => handleViewClick(rowData.key, rowData.leadName)}

          />
        </div>

        {/* Filters on the right side */}
        <div
          className="lead-list-filter"
          style={{
            display: isOpenFilter ? "block" : "none",
          }}
        >
          <LeadFilterOptions
            isOpenFilter={isOpenFilter}
            setIsOpenFilter={setIsOpenFilter}
            selectedLeadsFilter={selectedLeadsFilter}
            setSelectedLeadsFilters={setSelectedLeadsFilters}
            selectedLeadsFilterOptions={selectedLeadsFilterOptions}
            setAlertMessage={setAlertMessage}
            setAlertType={setAlertType}
            setAlertOpen={setAlertOpen}
            setSelectedLeadsFilterOptions={setSelectedLeadsFilterOptions}
            isAssign={false}
            onApplyFilters={(filters: any) => {
              setActiveFilters?.(filters);
              setCurrentPage(1);
            }}
            activeFilters={activeFilters}
          />
        </div>
      </div>
    </div>
  );
};

export default LeadsListTable;
